import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip, Legend } from "recharts";
import { Recycle } from "lucide-react";
import { PALETTE, fmt, KPI } from "./_shared";

export function WasteTab({ overview, rows }) {
  const pieData = [
    { name: "General",   value: overview.waste.general_kg,   colour: "#94A3B8" },
    { name: "Recyclable", value: overview.waste.recyclable_kg, colour: PALETTE.emerald },
    { name: "Hazardous", value: overview.waste.hazardous_kg, colour: PALETTE.s1 },
  ];
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <KPI label="General (kg)"    value={fmt(overview.waste.general_kg)}    icon={Recycle} tone="default" />
        <KPI label="Recyclable (kg)" value={fmt(overview.waste.recyclable_kg)} tone="good" />
        <KPI label="Hazardous (kg)"  value={fmt(overview.waste.hazardous_kg)}  tone="danger" />
        <KPI label="Diverted %"      value={`${overview.waste.diverted_pct}%`} tone={overview.waste.diverted_pct >= 40 ? "good" : "warn"} />
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div className="rounded-lg border border-slate-200 bg-white p-4">
          <div className="text-sm font-medium text-slate-800 mb-2">Waste Mix</div>
          <ResponsiveContainer width="100%" height={280}>
            <PieChart>
              <Pie data={pieData} dataKey="value" nameKey="name" innerRadius={60} outerRadius={100} paddingAngle={2}>
                {pieData.map((d) => <Cell key={d.name} fill={d.colour} />)}
              </Pie>
              <Tooltip formatter={(v) => `${fmt(v)} kg`} contentStyle={{ fontSize: "12px" }} />
              <Legend wrapperStyle={{ fontSize: "11px" }} />
            </PieChart>
          </ResponsiveContainer>
        </div>
        <div className="rounded-lg border border-slate-200 bg-white p-4">
          <div className="text-sm font-medium text-slate-800 mb-2">Waste Records ({rows.length})</div>
          <div className="max-h-64 overflow-y-auto divide-y divide-slate-100">
            {rows.slice(0, 40).map((r) => (
              <div key={r.id} className="grid grid-cols-5 gap-2 py-1.5 text-xs">
                <div className="font-mono text-slate-500">{r.business_unit_code}</div>
                <div className="text-slate-700">{r.period_month}</div>
                <div className="text-right">{fmt(r.general_kg)}</div>
                <div className="text-right text-emerald-700">{fmt(r.recyclable_kg)}</div>
                <div className="text-right text-rose-700">{fmt(r.hazardous_kg)}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
